export const SUPER_ADMIN = `superAdmin`
export const ADMIN = `admin`
export const GROUP_ADMIN = `groupAdmin`
export const USER = `user`
export const COM_INFOTECHCORP_PLANNER_ADMIN = `com.infotechcorp.planner.admin`
export const COM_INFOTECHCORP_PLANNER_EDITOR = `com.infotechcorp.planner.editor`
export const COM_INFOTECHCORP_PLANNER_VIEWER = `com.infotechcorp.planner.viewer`
export const COM_INFOTECHCORP_PLANNER_APPROVER = `com.infotechcorp.planner.approver`
export const REFERENCE_ADMIN = `ReferenceAdmin`
export const REFERENCE_SYSTEM_ADMIN = `ReferenceSystemAdmin`
export const REPORT_ADMIN = `ReportAdmin`
